import React from 'react';
import { Paper, Typography } from '@mui/material';
import ProcurementContainer from '../../procurement/containers/ProcurementContainer';
import PaymentRequestsDashboard from '../lists/paymentRequestsDashboard';

const PaymentRequestsDashboardPage: React.FC = () => {
  return (
    <ProcurementContainer>
      <Typography variant="h1" gutterBottom style={{ fontWeight: 'bold', color: '#123456' }}>
        Payment Requests Dashboard
      </Typography>
      <Paper sx={{ my: 5, p: 2, borderRadius: 3, backgroundColor: '#F4F7FB' }}>
        <PaymentRequestsDashboard />
      </Paper>
    </ProcurementContainer>
  );
};

export default PaymentRequestsDashboardPage;
